import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-1 ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Stagger = ({ children, className = "" }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.12 } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "" }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y: 30 },
      show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);

export const Squiggle = ({ className = "text-brand-coral" }) => (
  <svg viewBox="0 0 220 14" fill="none" className={className} aria-hidden="true">
    <path
      d="M3 10c20-8 37-8 55 0s35 8 55 0 35-8 55 0 32 8 49 2"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
    />
  </svg>
);

export const Chapter = ({ number, title, kicker }) => (
  <div className="flex items-start gap-5 md:gap-8">
    <span className="font-display text-6xl md:text-8xl font-bold leading-none text-outline select-none">
      {number}
    </span>
    <div className="pt-2 md:pt-4">
      {kicker && (
        <p className="uppercase tracking-[0.25em] text-xs font-bold text-brand-deepsky mb-2">{kicker}</p>
      )}
      <h2 className="text-3xl md:text-5xl font-semibold tracking-tight">{title}</h2>
    </div>
  </div>
);
